export default function (tribunal) {
  let window, title
  if (typeof tribunal !== 'undefined' && tribunal) {
    window = tribunal.id ? `tribunal.${tribunal.id}` : 'tribunal.new'
    title = 'Visualizar Tribunal'
  } else {
    window = 'tribunal.new'
    title = 'Novo Tribunal'
  }

  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: title,
    width: '500',
    height: '60%',
    minWidth: '500px',
    minHeight: '500px',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      id: tribunal?.id
    }
  }, () => import('./Tribunal'))
      .then((wid) => {
        console.log(wid)
        this.$uloc.window.listen(wid, {
          update: (wid, val) => {
            console.log('Atualizado: ', val)
            this.updateList(val)
          }
        })
      }) // return wid
}
